import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const AddressFieldWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
	position: relative;

	.copy-button-mobile {
		display: none;
	}

	.copy-button-desktop {
		display: flex;
	}

	@media ${Breakpoints.tablet} {
		.copy-button-desktop {
			display: none;
		}
		.copy-button-mobile {
			display: flex;
			width: 100%;
		}
	}
`;

export const TitleWrapper = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	gap: 1rem;
`;

export const Title = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 0.5rem;
`;

export const AddressFieldValues = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1.5rem;
	border: 1px solid var(--border-color);
	padding: 2rem;
	border-radius: 0.5rem;
	position: relative;
`;

export const AddressItems = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	gap: 1rem;

	@media ${Breakpoints.tablet} {
		flex-direction: column;
		align-items: flex-start;
	}
`;

export const AddressValue = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 1rem;

	@media ${Breakpoints.tablet} {
		width: 100%;
		align-items: center;
		justify-content: space-between;
	}
`;

export const TrackingDetailsWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
`;

export const FormWrapper = styled.div`
	display: grid;
	gap: 1rem;
	grid-template-columns: repeat(2, 1fr);

	.form-item {
		padding-inline: 0;
	}

	@media ${Breakpoints.tablet} {
		grid-template-columns: 1fr;
	}
`;

export const InstructionsWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
`;

export const Instructions = styled.div`
	display: flex;
	flex-direction: row;
	gap: 1rem;
	align-items: start;

	.icon {
		background-color: var(--background-3);
		color: var(--black);
		padding: 0.5rem;
		border-radius: 50%;
	}
`;

export const TextWrapper = styled.div`
	display: flex;
	height: 100%;
	align-items: center;

	&.listInstruction {
		padding-top: 0.75rem;
		@media ${Breakpoints.mobile} {
			padding-top: unset;
		}
	}
`;
